import styled from "styled-components";

export const Container = styled.div``;

export const InputFullGray = styled.input<{
  isMobile?: boolean;
  isValid?: boolean;
}>`
  width: ${(props) => (props.isMobile ? "95%" : "200px")};
  position: relative;
  height: 10px;
  border-radius: 8px;
  padding: 10px 30px 10px 14px;

  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #101828;
  bottom: 10px;

  &:focus {
    outline: none;
  }
`;
